(function () {
  'use strict';
  const E = window.FTNativeEngine;
  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  async function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const panel = root.querySelector('[data-ft-options]');
    const status = root.querySelector('[data-ft-status]');
    const button = root.querySelector('[data-ft-cart]');
    const cartButtons = [...root.querySelectorAll('[data-ft-cart]')];
    const dialog = root.querySelector('[data-ft-dialog]');
    let dialogTrigger;
    root.querySelectorAll('[data-ft-open]').forEach(b => b.addEventListener('click', () => { dialogTrigger = b; dialog.showModal(); }));
    root.querySelector('[data-ft-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => dialogTrigger?.focus());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    cartButtons.slice(1).forEach(b => b.addEventListener('click', () => button.click()));
    const quantity = root.querySelector('[data-ft-quantity]');
    const bridge = root.querySelector('[data-ft-bridge]');
    let busy = false;
    const mobileLayout = window.matchMedia('(max-width:900px)');
    // Scope viewer sizing and stickiness to this configurator's product section.
    const layout = root.closest('[data-ft-product-layout]') || root.closest('.preview-layout');
    const media = layout?.querySelector('[data-ft-sticky-media], .preview-media');
    const inlineCart = root.querySelector('.inline-cart');
    if (media && inlineCart) {
      let frame;
      const positionMedia = () => {
        frame = null;
        const top = parseFloat(getComputedStyle(media).top) || 0;
        const productVideo = layout?.querySelector(
  '.ft-reference-sidebar .review-videos'
);

const stopAtVideo = !mobileLayout.matches && productVideo;

const stopPosition = stopAtVideo
  ? productVideo.getBoundingClientRect().bottom
  : inlineCart.getBoundingClientRect().top - 12;

const shift = Math.min(
  0,
  stopPosition - media.offsetHeight - top
);
        media.style.setProperty('--ft-media-shift', shift + 'px');
      };
      const scheduleMedia = () => { if (!frame) frame = requestAnimationFrame(positionMedia); };
      const sizeViewer = () => {
        // Preserve the existing viewer and controls; allow the canvas's ancestors
        // to use the responsive media height instead of a fixed app height.
        media.querySelectorAll('canvas').forEach(canvas => {
          canvas.classList.add('ft-viewer-canvas');
          for (let node = canvas.parentElement; node && node !== media; node = node.parentElement) node.classList.add('ft-viewer-fill');
        });
        media.querySelectorAll('button,[role="button"]').forEach(button => {
          if ((button.textContent || '').trim().toLowerCase() === 'reset options' || (button.getAttribute('aria-label') || '').trim().toLowerCase() === 'reset options') {
            button.hidden = true; button.style.setProperty('display', 'none', 'important');
          }
        });
        scheduleMedia();
      };
      window.addEventListener('scroll', scheduleMedia, {passive:true});
      window.addEventListener('resize', scheduleMedia, {passive:true});
      const observer = new ResizeObserver(scheduleMedia); observer.observe(root); observer.observe(media);
      new MutationObserver(sizeViewer).observe(media, {childList:true, subtree:true});
      sizeViewer();
    }
    try {
      const embeddedSchema = root.querySelector('[data-ft-schema]');
      let schema;
      if (embeddedSchema) schema = JSON.parse(embeddedSchema.textContent);
      else {
        const response = await fetch(root.dataset.schemaUrl);
        if (!response.ok) throw new Error('Could not load the configuration data.');
        schema = await response.json();
      }
      const catalog = JSON.parse(root.querySelector('[data-ft-catalog]').textContent);
      let state = E.transition(schema, E.defaults(schema), null, null, 'on-load');
      const money = new Intl.NumberFormat(root.dataset.locale || 'en', {style: 'currency', currency: root.dataset.currency || 'EUR'});
      const format = amount => money.format(amount / 100);
      // This explicit offer setting must match the Shopify discount code.
      const discountPercent = root.dataset.discountCode ? Math.min(100, Math.max(0, Number(root.dataset.ftDiscountPercent) || 0)) : 0;
      const discounted = price =>
  price - Math.floor((price * discountPercent) / 100 + 1e-8);
      const saleCatalog = Object.fromEntries(Object.entries(catalog).map(([id, item]) => [id, {...item, price: discounted(item.price)}]));
      const originalCatalog = Object.fromEntries(Object.entries(catalog).map(([id, item]) => [id, {...item, price: Math.max(item.price, Number(item.compare_at_price) || 0)}]));
      function renderPrice(node, current, original = current, signed = false, compact = false) {
        const sign = signed ? current < 0 ? '−' : '+' : '';
        node.classList.add('ft-money'); node.replaceChildren();
        if (!compact && original > current && current >= 0) node.append(el('del', 'ft-price-original', sign + format(original)));
        const currentPrice = el('strong', 'ft-price-current', sign + format(Math.abs(current)));
        if (node.hasAttribute('data-ft-starting-price')) {
          const row = el('span', 'ft-current-row'); row.append(el('small', 'ft-from-text', 'From'), currentPrice); node.append(row);
        } else node.append(currentPrice);
        if (!compact) node.append(el('small', 'ft-price-net', sign + format(Math.abs(current) / 1.19) + ' excl. VAT'));
        node.dataset.currentPrice = current; node.dataset.originalPrice = original;
      }
      root.querySelectorAll('[data-ft-starting-price]').forEach(node => {
        const price = Number(node.dataset.ftStartingPrice);
        renderPrice(node, price, Math.max(price, Number(node.dataset.ftStartingCompare) || 0));
      });
      const controls = new Map(schema.controls.map(c => [c.key, c]));
      const fields = new Map();
      const messages = [];
      const groups = [];
      const labelFor = key => controls.get(key)?.options.find(o => o.value === state[key])?.label || state[key] || '';
      function configurationText() {
        const values = [labelFor('c_31'), (Number(state.c_1) / 10) + ' cm', labelFor('c_25')];
        if (state.c_31 === 'Rack-Mounted') values.push(state.c_2 + ' mm extension', labelFor('c_3'));
        return values.join(' · ');
      }
      panel.replaceChildren();
      // Only one such configurator should appear on a product page. The viewer
      // binds these stable names; visible inputs use separate names.
      for (const c of schema.controls) {
        const options = c.type === 'checkbox' ? c.options : [{value:''}, ...c.options];
        options.forEach((o, i) => {
          const input = el('input');
          input.type = c.type === 'checkbox' ? 'checkbox' : 'radio';
          input.name = 'ft-native-' + c.key + (c.type === 'checkbox' ? '-' + i : '');
          input.value = o.value;
          input.dataset.control = c.key;
          bridge.append(input);
        });
      }
      // Reuse the reference popup classes and native dialog keyboard behaviour.
      const detailScope = el('div', 'ft-reference');
      const detailDialog = el('dialog', 'detail-dialog');
      detailDialog.dataset.ftComponentDialog = '';
      const detailHeader = el('div', 'dialog-header');
      const detailTitle = el('h2');
      detailTitle.id = 'ft-component-title-' + (root.dataset.instanceId || 'preview');
      detailDialog.setAttribute('aria-labelledby', detailTitle.id);
      const detailClose = el('button', 'icon-button');
      detailClose.type = 'button';
      detailClose.setAttribute('aria-label', 'Close component details');
      detailClose.innerHTML = '<svg class="icon" aria-hidden="true"><use href="#ft-ref-i-close"></use></svg>';
      const detailBody = el('div', 'detail-body');
      detailHeader.append(detailTitle, detailClose);
      detailDialog.append(detailHeader, detailBody); detailScope.append(detailDialog); root.append(detailScope);
      let detailTrigger;
      detailClose.addEventListener('click', () => detailDialog.close());
      detailDialog.addEventListener('close', () => detailTrigger?.focus());
      detailDialog.addEventListener('click', event => {
        if (event.target !== detailDialog) return;
        const r = detailDialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) detailDialog.close();
      });
      function optionParts(c, o) {
        const related = condition => Array.isArray(condition) ? condition.some(related) : condition?.conditions ? condition.conditions.some(related) :
          condition?.name === c.key && condition.value === o.value || condition?.name === c.key + '__' + o.value && condition.value === true;
        const candidates = schema.parts.filter(p => related(p.advancedVariantMatch || p.variantMatch));
        const next = {...state, [c.key]: c.type === 'checkbox' ? [...new Set([...(state[c.key] || []), o.value])] : o.value};
        const active = candidates.filter(p => E.match(p.advancedVariantMatch || p.variantMatch, E.expand(schema, next)));
        return active.length ? active : candidates.slice(0, 1);
      }
      function showDetails(c, o, label, input, trigger) {
        const parts = optionParts(c, o);
        const part = parts[0];
        const id = part?.catalogRef.variantId.split('/').pop();
        const product = catalog[id];
        detailTitle.textContent = product?.product_title || part?.catalogRef.title || o.label;
        const image = el('img'); image.src = o.imageUrl || part?.catalogRef.imageUrl || ''; image.alt = detailTitle.textContent;
        const copy = el('div', 'detail-copy');
        const price = label.querySelector('.ft-choice-price')?.textContent || (product ? '+' + format(product.price * (part.quantity || 1)) : '');
        const priceBox = el('div', 'detail-price');
        const cardPrice = label.querySelector('.ft-choice-price');
        renderPrice(priceBox, Number(cardPrice?.dataset.currentPrice ?? product?.price ?? 0), Number(cardPrice?.dataset.originalPrice ?? product?.price ?? 0), true, true);
        copy.append(priceBox);
        const action = el('button', 'primary-button'); action.type = 'button';
        const canRemove = c.type === 'checkbox' || c.allowNone;
        const logicDisabled = !E.match(o.enabledWhen, E.expand(schema, state));
        action.textContent = logicDisabled ? 'UNAVAILABLE FOR THIS CONFIGURATION' : input.checked ? (canRemove ? 'REMOVE FROM BUILD' : 'SELECTED FOR MY BUILD') : input.disabled ? 'OUT OF STOCK' : 'SELECT FOR MY BUILD';
        action.disabled = input.disabled || input.checked && !canRemove;
        action.addEventListener('click', () => {
          if (busy || action.disabled) return;
          const value = c.type === 'checkbox' ? (state[c.key] || []).includes(o.value) ? state[c.key].filter(v => v !== o.value) : [...(state[c.key] || []), o.value] : state[c.key] === o.value && canRemove ? '' : o.value;
          change(c.key, value); detailDialog.close();
        });
        copy.append(action);
        if (product?.url) {
          const link = el('a', '', 'View full product specifications');
          link.href = product.url; link.target = '_blank'; link.rel = 'noopener'; copy.append(link);
        }
        detailBody.replaceChildren(image, copy);
        detailTrigger = trigger;
        detailDialog.showModal();
      }
      function controlNode(c) {
        const field = el('fieldset', 'bb-control bb-fieldset');
        field.dataset.ftField = c.key;
        const legend = el('legend', 'bb-label', c.key === 'c_1' ? 'Height' : c.label);
        if (c.optionDisplay === 'swatch') legend.append(el('span', '', ': '), el('span', 'ft-color-value'));
        field.append(legend);
        const wrap = el('div', c.optionDisplay === 'card' ? 'bb-option-cards' : c.optionDisplay === 'swatch' ? 'bb-swatches' : 'bb-option-buttons');
        const choices = [];
        for (const o of c.options) {
          const className = c.optionDisplay === 'card' ? 'bb-option-card' : c.optionDisplay === 'swatch' ? 'bb-swatch-item' : 'bb-option-button';
          const label = el('label', className);
          const input = el('input', 'ft-sr');
          input.type = c.type === 'checkbox' ? 'checkbox' : 'radio';
          input.name = 'ft-ui-' + c.key;
          input.value = o.value;
          input.dataset.ftChoice = c.key;
          input.setAttribute('aria-label', o.label);
          label.append(input);
          // Native radios do not toggle off. For optional choices, intercept
          // activation of the selected card before the label's default action.
          // State is authoritative because an input click may already have
          // changed its checked property before this listener runs.
          if (c.type === 'radio' && c.allowNone) {
            label.addEventListener('click', event => {
              if (busy || input.disabled || state[c.key] !== o.value) return;
              event.preventDefault();
              // Wait for cancelled native radio activation to restore its
              // checked property, then commit the deselection consistently.
              queueMicrotask(() => change(c.key, ''));
            });
          }
          if (c.optionDisplay === 'swatch') {
            const swatch = el('span', 'bb-swatch');
            swatch.style.background = o.colors?.length ? `linear-gradient(${o.swatchAngleDeg ?? 135}deg,${o.colors[0]} 50%,${o.colors[1]} 50%)` : o.color;
            label.append(swatch, el('span', 'ft-sr', o.label));
          } else if (c.optionDisplay === 'card') {
            if (o.imageUrl) { const image = el('img', 'bb-option-card-image'); image.src = o.imageUrl; image.alt = ''; image.loading = 'lazy'; label.append(image); }
            label.append(el('span', 'bb-option-card-title', o.label));
          } else label.append(el('span', 'bb-option-text', c.key === 'c_1' ? (o.value === '2300' ? 'Tall · 230 cm' : 'Standard · 210 cm') : c.key === 'c_25' ? o.label.replace(/^2\s*[x×]\s*/i, '') : o.label));
          if (c.optionDisplay !== 'swatch') {
            if (c.optionDisplay === 'card') label.append(el('span', 'ft-choice-check', '✓'));
            if (c.optionDisplay === 'card') label.append(el('span', 'ft-choice-price'));
          }
          label.title = o.description || o.label;
          const container = c.optionDisplay === 'card' ? el('div', 'ft-option-card-shell') : label;
          if (c.optionDisplay === 'card') {
            const details = el('button', 'component-detail', 'Details'); details.type = 'button';
            details.setAttribute('aria-label', 'Details about ' + c.label.replace(' (optional)', '') + ': ' + o.label);
            details.addEventListener('click', () => showDetails(c, o, label, input, details));
            container.append(label, details);
          }
          wrap.append(container);
          choices.push({o, label, input, container});
        }
        field.append(wrap);
        fields.set(c.key, {field, choices, legend});
        return field;
      }
      for (const item of schema.elements) {
        if (item.type === 'text') continue;
        const accordion = el('div', 'bb-accordion');
        const heading = el('h3', 'bb-accordion-heading');
        const toggle = el('button', 'bb-accordion-header');
        toggle.type = 'button'; toggle.setAttribute('aria-expanded', 'true');
        const number = String(groups.length + 1).padStart(2, '0');
        const groupSummary = el('span', 'ft-group-summary');
        toggle.append(el('span', 'ft-group-number', number), el('span', 'bb-accordion-title', item.title === 'Main Options' ? 'Your trainer' : item.title), groupSummary, el('span', 'bb-accordion-chevron'));
        groups.push({item, groupSummary});
        const body = el('div', 'bb-accordion-inner');
        if (groups.length > 1) { body.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
        body.id = 'ft-group-' + (root.dataset.instanceId || 'preview') + '-' + item.id;
        toggle.setAttribute('aria-controls', body.id);
        toggle.addEventListener('click', () => { body.hidden = !body.hidden; toggle.setAttribute('aria-expanded', String(!body.hidden)); });
        for (const child of item.children) {
          if (child.type === 'control') body.append(controlNode(controls.get(child.controlKey)));
          else if (child.type === 'message') {
            const message = el('div', 'bb-message bb-message-info', child.text);
            body.append(message); messages.push({node:message, condition:child.advancedVariantMatch || child.variantMatch});
          }
        }
        heading.append(toggle); accordion.append(heading, body); panel.append(accordion);
      }
      function buildQuantity() {
        return Number(quantity.value);
      }
      function change(key, value) {
        state = E.transition(schema, state, key, value);
        update();
      }
      function syncBridge() {
        const changed = [];
        bridge.querySelectorAll('input').forEach(input => {
          const value = state[input.dataset.control];
          const checked = input.type === 'checkbox' ? (value || []).includes(input.value) : value === input.value;
          if (input.checked !== checked) { input.checked = checked; changed.push(input); }
        });
        // Commit ALL fields before notifying the viewer, so each collection pass
        // sees a settled configuration, including derived checkbox booleans.
        (changed.length ? changed : [bridge.querySelector('input:checked')]).filter(Boolean).forEach(input => input.dispatchEvent(new Event('change', {bubbles:true, composed:true})));
      }
      function unavailable(c, o) {
        const nextValue = c.type === 'checkbox' ? [...new Set([...(state[c.key] || []), o.value])] : o.value;
        const alreadySelected = c.type === 'checkbox'
  ? (state[c.key] || []).includes(o.value)
  : state[c.key] === o.value;

const next = alreadySelected
  ? state
  : E.transition(schema, state, c.key, nextValue);
        const previous = new Set(E.parts(schema, state).map(p => p.id));
        const relevant = E.parts(schema, next).filter(p => {
          const rule = JSON.stringify(p.advancedVariantMatch || p.variantMatch || []);
          return !previous.has(p.id) || rule.includes('"' + c.key + '"') || rule.includes('"' + c.key + '__');
        });
        const ids = new Set(relevant.map(p => p.catalogRef.variantId.split('/').pop()));
        return E.stockErrors(E.bom(schema, next, buildQuantity()).filter(l => ids.has(l.id)), catalog).length > 0;
      }
      function settleStockSelections() {
  // Resolve unavailable optional extras before core selections.
  const optional = c => c.type === 'checkbox' || c.allowNone;

  const stockOrder = [
    ...schema.controls.filter(optional),
    ...schema.controls.filter(c => !optional(c))
  ];

  const seen = new Set();

  for (let pass = 0; pass < schema.controls.length; pass++) {
    const signature = JSON.stringify(state);
    if (seen.has(signature)) break;
    seen.add(signature);

    let changed = false;

    for (const c of stockOrder) {
      if (!E.visible(schema, c, state)) continue;

      const selected = c.options.filter(o =>
        c.type === 'checkbox'
          ? (state[c.key] || []).includes(o.value)
          : state[c.key] === o.value
      );

      for (const o of selected) {
        if (!unavailable(c, o)) continue;

        let next;

        if (c.type === 'checkbox') {
          next = E.transition(
            schema,
            state,
            c.key,
            state[c.key].filter(v => v !== o.value)
          );
        } else if (c.allowNone) {
          next = E.transition(schema, state, c.key, '');
        } else {
          const values = E.expand(schema, state);

          const alternative = c.options.find(candidate =>
            candidate.value !== o.value &&
            E.match(candidate.visibleWhen, values) &&
            E.match(candidate.enabledWhen, values) &&
            !unavailable(c, candidate)
          );

          if (alternative) {
            next = E.transition(
              schema,
              state,
              c.key,
              alternative.value
            );
          }
        }

        if (next && !seen.has(JSON.stringify(next))) {
          state = next;
          changed = true;
          break;
        }
      }

      // Restart with the repaired configuration.
      if (changed) break;
    }

    if (!changed) break;
  }
}
      function update() {
        const qty = buildQuantity();
        if (Number.isSafeInteger(qty) && qty >= 1 && !busy) settleStockSelections();
        const values = E.expand(schema, state);
        const validQty = Number.isSafeInteger(qty) && qty >= 1;
        fields.forEach(({field, choices, legend}, key) => {
          const c = controls.get(key);
          field.hidden = !E.visible(schema, c, state);
          choices.forEach(({o, label, input, container}) => {
            label.hidden = !E.match(o.visibleWhen, values);
            container.hidden = label.hidden;
            const logicDisabled = !E.match(o.enabledWhen, values);
            const stockDisabled = !field.hidden && !label.hidden && validQty && unavailable(c, o);
            input.checked = c.type === 'checkbox' ? (state[key] || []).includes(o.value) : state[key] === o.value;
            // Unavailable selections are settled above; sold-out choices stay disabled.
            input.disabled = busy || logicDisabled || stockDisabled;
            label.classList.toggle('bb-option-disabled', logicDisabled || stockDisabled);
            const price = label.querySelector('.ft-choice-price');
            if (price && !field.hidden && !label.hidden) {
              try {
                const base = E.transition(schema, state, key, c.type === 'checkbox' ? (state[key] || []).filter(v => v !== o.value) : '');
                const selected = E.transition(schema, base, key, c.type === 'checkbox' ? [...(base[key] || []), o.value] : o.value);
                const selectedLines = E.bom(schema, selected, 1), baseLines = E.bom(schema, base, 1);
                const delta = E.total(selectedLines, saleCatalog) - E.total(baseLines, saleCatalog);
                const original = E.total(selectedLines, originalCatalog) - E.total(baseLines, originalCatalog);
                renderPrice(price, delta, original, true, true);
              } catch (_) { price.textContent = ''; }
            }
            label.title = logicDisabled ? o.disabledHint || 'Unavailable for this configuration' : stockDisabled ? 'Sold out for this configuration' : o.description || o.label;
          });
          const colorText = legend.querySelector('.ft-color-value');
          if (colorText) colorText.textContent = state[key];
        });
        messages.forEach(m => { m.node.hidden = !E.match(m.condition, values); });
        let lines = [];
        const errors = E.validate(schema, state);
        try {
          lines = E.bom(schema, state, qty);
          errors.push(...E.stockErrors(lines, catalog));
          root.querySelectorAll('[data-ft-total]').forEach(node => { renderPrice(node, E.total(lines, saleCatalog), E.total(lines, originalCatalog)); });
        } catch (error) { errors.push(error.message); root.querySelectorAll('[data-ft-total], [data-ft-ex-vat]').forEach(node => { node.textContent = '—'; }); }
        const breakdown = root.querySelector('[data-ft-breakdown]');
        breakdown.replaceChildren();
        lines.forEach(line => {
          const row = el('div', 'ft-native-part');
          const image = el('img'); image.src = line.image || ''; image.alt = ''; image.loading = 'lazy';
          const linePrice = el('span', 'ft-line-money');
          if (catalog[line.id]) renderPrice(linePrice, saleCatalog[line.id].price * line.quantity, originalCatalog[line.id].price * line.quantity, false, true);
          else linePrice.textContent = '—';
          const title = (catalog[line.id]?.title || line.label || '')
  .replace(/\s*[—–-]\s*Default Title\s*$/i, '');

row.append(
  image,
  el('span', '', title + ' × ' + line.quantity),
  linePrice
);
          breakdown.append(row);
        });
        root.querySelectorAll('[data-ft-summary]').forEach(node => { node.textContent = configurationText(); });
        root.querySelectorAll('[data-ft-build-title]').forEach(node => { node.textContent = state.c_31 === 'Rack-Mounted' ? 'Functional Trainer & Rack' : 'Functional Trainer'; });
        groups.forEach(({item, groupSummary}, index) => {
          const selected = item.children.filter(child => child.type === 'control' && E.visible(schema, controls.get(child.controlKey), state)).flatMap(child => { const c = controls.get(child.controlKey); const v = state[c.key]; return Array.isArray(v) ? v : v && v !== 'None' ? [labelFor(c.key)] : []; });
          groupSummary.textContent = index === 0 ? state.c_31 : selected.length ? selected.join(', ') : 'Optional';
        });
        status.textContent = errors.join(' ');
        root.querySelector('[data-ft-dialog-status]').textContent = errors.join(' ');
        cartButtons.forEach(b => { b.disabled = busy || errors.length > 0; (b.querySelector('[data-ft-cart-label]') || b).textContent = busy ? 'Adding…' : (mobileLayout.matches && b.closest('.ft-build-bar') ? 'Add to cart' : (b.dataset.ftCartText || 'Add to cart')); });
        quantity.disabled = busy;
        syncBridge();
      }
      root.addEventListener('change', event => {
        const input = event.target;
        if (busy) return;
        if (input.hasAttribute('data-ft-quantity')) { update(); return; }
        const key = input.dataset.ftChoice;
        if (!key) return;
        const c = controls.get(key);
        const value = c.type === 'checkbox' ? [...root.querySelectorAll('[data-ft-choice="' + key + '"]:checked')].map(i => i.value) : input.value;
        change(key, value);
      });
      button.addEventListener('click', async () => {
        if (busy || button.disabled) return;
        if (root.hasAttribute('data-preview')) { const message = 'Preview only — no items have been added to a real cart.'; status.textContent = message; root.querySelector('[data-ft-dialog-status]').textContent = message; return; }
        busy = true; update();
        let submitted = false;
        try {
          const route = window.Shopify?.routes?.root || '/';
          const cartResponse = await fetch(route + 'cart.js', {headers:{Accept:'application/json'}});
          if (!cartResponse.ok) throw new Error('Could not check the current cart. Please try again.');
          const cart = await cartResponse.json();
          const cartQuantities = {};
          cart.items.forEach(item => { cartQuantities[String(item.variant_id)] = (cartQuantities[String(item.variant_id)] || 0) + item.quantity; });
          const lines = E.bom(schema, state, buildQuantity());
          const errors = [...E.validate(schema, state), ...E.stockErrors(lines, catalog, cartQuantities)];
          if (errors.length) throw new Error(errors.join(' '));
          const buildId = crypto.randomUUID();
          const properties = {_ft_configuration_id:buildId};
          submitted = true;
          const response = await fetch(route + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:lines.map(l => ({id:l.id, quantity:l.quantity, properties}))})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Shopify could not add this build. Review your cart before retrying.');
          // Refresh the product page after cart use to refresh Liquid catalog data.
          // Cart is the authoritative result; do not pretend local arithmetic
          // predicts automatic discounts or tax treatment.
          const discountCode = root.dataset.discountCode;
          window.location.assign(discountCode ? '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(route + 'cart') : route + 'cart');
        } catch (error) {
          busy = false; update();
          status.textContent = submitted ? error.message + ' Check your cart before trying again; the request may have reached Shopify.' : error.message;
          root.querySelector('[data-ft-dialog-status]').textContent = status.textContent;
        }
      });
      mobileLayout.addEventListener('change', update);
      update();
    } catch (error) {
      status.textContent = error.message;
      panel.replaceChildren(el('p', '', 'The configurator could not load. Please contact us.'));
      cartButtons.forEach(b => { b.disabled = true; });
    }
  }
  const boot = scope => scope.querySelectorAll('[data-ft-native]').forEach(mount);
  boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();

(() => {
  const updateBuildBar = () => {
    document.querySelectorAll('.ft-native .ft-build-bar').forEach(bar => {
      bar.classList.toggle('is-scrolled', window.scrollY > 30);
    });
  };

  window.addEventListener('scroll', updateBuildBar, { passive: true });
  window.addEventListener('pageshow', updateBuildBar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBuildBar, { once: true });
  } else {
    updateBuildBar();
  }
})();

(() => {
  function init() {
    if (!document.querySelector('[data-ft-native]')) return;

    function releaseHiddenPopupLock() {
      const body = document.body;

      if (!body.classList.contains('klaviyo-prevent-body-scrolling')) {
        return;
      }

      const popups = [
        ...document.querySelectorAll(
          'div[role="dialog"][aria-label="POPUP Form"]'
        )
      ];

      // Only release the lock when a popup exists but none is displayed.
      if (!popups.length) return;

      const visiblePopup = popups.some(popup =>
        popup.getClientRects().length > 0 &&
        getComputedStyle(popup).visibility !== 'hidden'
      );

      if (!visiblePopup) {
        body.classList.remove('klaviyo-prevent-body-scrolling');
      }
    }

    const observer = new MutationObserver(releaseHiddenPopupLock);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    releaseHiddenPopupLock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();